import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-exit',
  templateUrl: './icon-exit.component.html',
  styleUrls: ['./icon-exit.component.scss']
})
export class IconExitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
